import MethodService from "../../../../service/MethodService";
import ShiftApi from "../../../../moduleApi/ShiftApi";
import EmployeeShiftApi from "../../../../moduleApi/EmployeeShiftApi";
import EmployeeApi from "../../../../moduleApi/EmployeeApi";
import RequestReasonApi from "../../../../moduleApi/RequestReasonApi";
import DayOffApi from "../../../../moduleApi/DayOffApi";
import EmployeeDayOffApi from "../../../../moduleApi/EmployeeDayOffApi";
import BranchApi from "../../../../moduleApi/BranchApi";
import DepartmentApi from "../../../../moduleApi/DepartmentApi";
import { result } from "lodash";

export const fnMixins = {
  methods: {
    fn_setLabelRespectively(item) {
      if (!item) return "Không xác định";
      const fullName =
        item.administrative_info &&
        item.administrative_info.name &&
        item.administrative_info.name.full_name
          ? item.administrative_info.name.full_name
          : item.full_name || "";
      return `${item.employee_no ? item.employee_no : ''} - ${fullName}`;
    },

    async fn_initDataShift() {
      this.createRequest = true;
      // For certain request types we need QLTT approvers (role code),
      // otherwise use the default DIRECT_MANAGER behavior.
      const qlttTypes = [
        'DAY_OFF',
        'GO_LATE',
        'TIME_KEEPING_ONLINE',
        'WORK_ADDITION',
        'OT',
        'GO_HOME_EARLY',
        'COME_BACK_SOON',
        'GO_OUT',
        'GO_ON_BUSSINESS',
        'WIFI_ATTENDANCE',
        'WORK_EXPLANATION'
      ];

      if (qlttTypes.includes(this.typeReq)) {
        await this.fn_getListEmployeeApprovedQLTT(
          this.mData.dataForm.employee_request.employee_id,
          false
        );
      } else {
        await this.fn_getListEmployeeApproved(
          this.mData.dataForm.employee_request.employee_id,
          false
        );
      }
      let dataFilter = {
        filters:
          this.mData.tableRules.filters +
          (this.mData.tableRules.filters ? "&" : "") +
          (
            this.mData.dataForm.employee_request.employee_id ?
              "employee_id=" +
              this.mData.dataForm.employee_request.employee_id : ""
          )
        ,
        fields: "shift_id,start_time,end_time"
      };
      this.listEmployeeShift = []; //reset data
      let res = await EmployeeShiftApi.list(dataFilter);
      if (res.result) {
        const currentTime = new Date().getTime();
        if (this.mData.dataForm.detail_request.explained_start_date) {
          const workExplainTime = this.mData.dataForm.detail_request.explained_start_date.getTime();
          res.result.forEach(el => {
            if (el.start_time && el.end_time) {
              const startTime = new Date(el.start_time).getTime();
              const endTime = new Date(el.end_time).getTime();
              if (workExplainTime >= startTime && workExplainTime <= endTime) {
                this.listEmployeeShift.push(el);
              }
            } else if (el.start_time && !el.end_time) {
              const startTime = new Date(el.start_time).getTime();
              if (workExplainTime >= startTime) {
                this.listEmployeeShift.push(el);
              }
            }
          });
        } else {
          res.result.forEach(el => {
            if (el.start_time && el.end_time) {
              const startTime = new Date(el.start_time).getTime();
              const endTime = new Date(el.end_time).getTime();
              if (currentTime >= startTime && currentTime <= endTime) {
                this.listEmployeeShift.push(el);
              }
            } else if (el.start_time && !el.end_time) {
              const startTime = new Date(el.start_time).getTime();
              if (currentTime >= startTime) {
                this.listEmployeeShift.push(el);
              }
            }
          });
        }
        this.listEmployeeShift.reverse();
        this.listEmployeeShift = await this.fn_changeData(this.listEmployeeShift);
        if (
          this.listEmployeeShift.length == 0 &&
          this.mData.dataForm.employee_request.employee_id
        ) {
          window.toastr.warning(
            "Nhân viên hiện không có ca hiệu lực để tạo yêu cầu !"
          );
        }
      }
      // reset the input field
      await this.fn_resetReSelectEmployee();
    },
    async fn_changeData(resData) {
      let shiftIds = [];
      shiftIds = MethodService.findListItemDifferent(resData, "shift_id");
      const shiftApiRes = await ShiftApi.list({
        limit: shiftIds.length,
        filters: "id:in:" + shiftIds.join(",")
      });
      this.listEmployeeShiftDetail = shiftApiRes.result;
      if (this.listEmployeeShiftDetail.length > 0) {
        resData.forEach(item => {
          let caLamViec = this.listEmployeeShiftDetail.find(element => {
            return element.id == item.shift_id;
          });
          if (caLamViec) {
            if (caLamViec.is_odd_shift) {
              item.ten_ca = caLamViec.odd_names;
            } else {
              item.ten_ca = [caLamViec.name];
            }
          } else {
            item.ten_ca = "Chưa có thông tin";
          }
        });
        return resData;
      } else {
        return (resData = []);
      }
    },
    fn_canLoadAllRequestEmployees() {
      const features = this.mData.dataDefault.listFeature || [];
      const currentUser = this.currentUser || MethodService.getCurrentUser();
      return features.includes("FT1007") ||
        !!(currentUser && currentUser.roles && currentUser.roles.includes("AdminSystem"));
    },

    fn_getRequestEmployeeListQuery(includeStatus = true) {
      const filters = ["disabled=false"];
      const canLoadAllEmployees = this.fn_canLoadAllRequestEmployees();

      if (includeStatus) {
        filters.push("status=DANG_LAM_VIEC");
      }

      if (!canLoadAllEmployees) {
        const currentUser = this.currentUser || MethodService.getCurrentUser();
        filters.push("id:in:" + (currentUser && currentUser.id ? currentUser.id : "__missing_current_user__"));
      }

      return {
        filters: filters.join("&"),
        limit: canLoadAllEmployees ? 3000 : 1
      };
    },

    async fn_getListEmployee() {
      const [employeeApiRes] = await Promise.all([
        EmployeeApi.list(this.fn_getRequestEmployeeListQuery(true)),
        this.fn_getRequestOrgOptions()
      ]);
      if (employeeApiRes.result && employeeApiRes.result.length > 0) {
        this.mData.dataDefault.listNhanVien = employeeApiRes.result;
      }
    },

    async fn_getListEmployeeWorkExplanation() {
      const [employeeApiRes] = await Promise.all([
        EmployeeApi.list(this.fn_getRequestEmployeeListQuery(false)),
        this.fn_getRequestOrgOptions()
      ]);
      if (employeeApiRes.result && employeeApiRes.result.length > 0) {
        this.mData.dataDefault.listEmployeeWorkExplanation = employeeApiRes.result;
      }
    },

    async fn_getRequestOrgOptions() {
      const requests = [];
      if (!this.mData.dataDefault.listDepartment.length) {
        requests.push(
          DepartmentApi.list({ limit: 1000000 }).then((res) => {
            this.mData.dataDefault.listDepartment = res.result || [];
          })
        );
      }
      if (!this.mData.dataDefault.listBranch.length) {
        requests.push(
          BranchApi.list({ limit: 1000000 }).then((res) => {
            this.mData.dataDefault.listBranch = res.result || [];
          })
        );
      }
      if (requests.length) {
        await Promise.all(requests);
      }
    },

    fn_getActiveJobInfo(employee) {
      const jobInfo = employee && employee.job_info ? employee.job_info : [];
      if (!jobInfo.length) return [];
      const now = Date.now();
      const activeJobs = jobInfo.filter((item) => {
        const startTime = item.start_date ? new Date(item.start_date).getTime() : 0;
        const endTime = item.end_date ? new Date(item.end_date).getTime() : Infinity;
        return startTime <= now && now <= endTime;
      });
      return activeJobs.length ? activeJobs : jobInfo;
    },

    fn_findRequestEmployeeById(employeeId) {
      if (!employeeId) return null;
      const employees = [
        ...(this.mData.dataDefault.listNhanVien || []),
        ...(this.mData.dataDefault.listEmployeeWorkExplanation || [])
      ];
      return employees.find((item) => item && item.id === employeeId) || null;
    },

    fn_getApprovalTargetScope(employeeId) {
      const employee = this.fn_findRequestEmployeeById(employeeId);
      const activeJob = this.fn_getActiveJobInfo(employee)[0] || {};
      return {
        company_id:
          (employee && employee.company_id) ||
          (this.currentCompany && this.currentCompany.id) ||
          undefined,
        // branch_id: activeJob.branch_id || undefined,
        // department_id: activeJob.department_id || undefined
      };
    },

    fn_filterEmployeesByRequestOrg(employees) {
      const departmentIds = this.requestEmployeeFilter.department_ids || [];
      const branchIds = this.requestEmployeeFilter.branch_ids || [];
      if (!departmentIds.length && !branchIds.length) return employees;
      return employees.filter((employee) => {
        const jobs = this.fn_getActiveJobInfo(employee);
        const matchDepartment =
          !departmentIds.length ||
          jobs.some((item) => departmentIds.includes(item.department_id));
        const matchBranch =
          !branchIds.length ||
          jobs.some((item) => branchIds.includes(item.branch_id));
        return matchDepartment && matchBranch;
      });
    },

    fn_resetEmployeeWhenFilteredOut() {
      const employeeId = this.mData.dataForm.employee_request.employee_id;
      if (!employeeId) return;
      const allEmployees = [
        ...(this.mData.dataDefault.listNhanVien || []),
        ...(this.mData.dataDefault.listEmployeeWorkExplanation || [])
      ];
      const currentEmployee = allEmployees.find((item) => item.id === employeeId);
      if (!currentEmployee) return;
      const isVisible = this.fn_filterEmployeesByRequestOrg([currentEmployee]).length > 0;
      if (!isVisible) {
        this.mData.dataForm.employee_request.employee_id = undefined;
        this.listEmployeeApprove = [];
        this.listHrApprove = [];
        if (this.$refs.myForm) {
          this.$nextTick(() => {
            const field = this.$refs.myForm.fields.find(
              (item) => item.prop === "employee_request.employee_id"
            );
            if (field) field.clearValidate();
          });
        }
      }
    },

    fn_mapApprovalEmployee(item) {
      const employee = item && item.e ? item.e : item;
      if (!employee || !employee.id) return null;

      return {
        ...item,
        e: {
          ...employee,
          administrative_info: employee.administrative_info || {
            name: {
              full_name: employee.full_name || ""
            },
            email: employee.email,
            phone_number: employee.phone_number
          }
        }
      };
    },

    fn_applyApprovalList(targetName, employees) {
      const mappedEmployees = (employees || [])
        .map(this.fn_mapApprovalEmployee)
        .filter(Boolean);
      this[targetName] = [
        ...new Map(mappedEmployees.map(item => [item.e.id, item])).values()
      ];
    },

    fn_resetApprovalWhenFilteredOut() {
      const directIds = (this.listEmployeeApprove || []).map(item => item.e && item.e.id);
      const hrIds = (this.listHrApprove || []).map(item => item.e && item.e.id);

      if (
        this.mData.dataForm.employee_request.level1Approval &&
        !directIds.includes(this.mData.dataForm.employee_request.level1Approval)
      ) {
        this.mData.dataForm.employee_request.level1Approval = undefined;
      }

      if (
        this.mData.dataForm.employee_request.level2Approval &&
        !directIds.includes(this.mData.dataForm.employee_request.level2Approval)
      ) {
        this.mData.dataForm.employee_request.level2Approval = undefined;
      }

      if (
        this.mData.dataForm.employee_request.employeeApproval &&
        !hrIds.includes(this.mData.dataForm.employee_request.employeeApproval)
      ) {
        this.mData.dataForm.employee_request.employeeApproval = undefined;
      }
    },

    fn_syncApprovalValidation() {
      if (!this.$refs || !this.$refs.myForm) return;

      this.$nextTick(() => {
        const form = this.$refs.myForm;
        if (
          this.mData.dataForm.employee_request.level2Approval
        ) {
          form.clearValidate("employee_request.level2Approval");
        }
        if (
          this.mData.dataForm.employee_request.employeeApproval
        ) {
          form.clearValidate("employee_request.employeeApproval");
        }
      });
    },

    // Get list nhân sự duyệt
    async fn_getListDirectManagerOptions(employeeId) {
      const selectedEmployeeId =
        employeeId ||
        this.mData.dataForm.employee_request.employee_id ||
        (this.currentUser ? this.currentUser.id : null);

      if (!this.mData || !this.mData.dataDefault) return;

      const selectedEmployee = this.fn_findRequestEmployeeById
        ? this.fn_findRequestEmployeeById(selectedEmployeeId)
        : null;
      const directManagerId = ((this.fn_getActiveJobInfo && selectedEmployee
        ? this.fn_getActiveJobInfo(selectedEmployee)
        : selectedEmployee && selectedEmployee.job_info
          ? selectedEmployee.job_info
          : []
      ).find((item) => item && item.direct_manager_id) || {}).direct_manager_id;

      if (!directManagerId) {
        this.mData.dataDefault.listQuanLyTrucTiep = [];
        this.mData.dataForm.employee_request.level2Approval = undefined;
        return;
      }

      try {
        const directManagerRes = await EmployeeApi.findById(directManagerId, true);
        const employee = directManagerRes && directManagerRes.result ? directManagerRes.result : null;
        const fullName =
          employee &&
          (employee.name ||
            employee.full_name ||
            (employee.administrative_info &&
            employee.administrative_info.name &&
            employee.administrative_info.name.full_name
              ? employee.administrative_info.name.full_name
              : ""));
        this.mData.dataDefault.listQuanLyTrucTiep = employee
          ? [{
            ...employee,
            name: employee.employee_no ? `${employee.employee_no} - ${fullName || ""}` : fullName || ""
          }]
          : [];

        this.mData.dataForm.employee_request.level2Approval =
          employee && employee.id ? employee.id : undefined;
        this.fn_syncApprovalValidation();
      } catch (error) {
        console.error("Load direct manager info failed", error);
        this.mData.dataDefault.listQuanLyTrucTiep = [];
        this.mData.dataForm.employee_request.level2Approval = undefined;
      }
    },

    async fn_getListEmployeeApproved(employeeId, allowCurrentUserFallback = true) {
      const selectedEmployeeId =
        employeeId ||
        this.mData.dataForm.employee_request.employee_id ||
        (allowCurrentUserFallback && this.currentUser ? this.currentUser.id : null);

      if (!selectedEmployeeId) {
        this.listEmployeeApprove = [];
        this.listHrApprove = [];
        return;
      }

      const targetScope = this.fn_getApprovalTargetScope(selectedEmployeeId);
      const basePayload = {
        employee_id: selectedEmployeeId,
        company_id: targetScope.company_id,
        // branch_id: targetScope.branch_id,
        // department_id: targetScope.department_id,
        feature_code: "FT1006",
        limit: 500
      };

      const [directManagerRes, hrManagerRes] = await Promise.all([
        EmployeeApi.GetDirectManagerCandidates({
          ...basePayload,
          approver_type: "DIRECT_MANAGER"
        }),
        EmployeeApi.GetDirectManagerCandidates({
          ...basePayload,
          approver_type: "HR"
        })
      ]);

      this.fn_applyApprovalList(
        "listEmployeeApprove",
        directManagerRes && directManagerRes.result
          ? directManagerRes.result.employees
          : []
      );
      this.fn_applyApprovalList(
        "listHrApprove",
        hrManagerRes && hrManagerRes.result
          ? hrManagerRes.result.employees
          : []
      );
      this.fn_resetApprovalWhenFilteredOut();
      await this.fn_getListDirectManagerOptions(selectedEmployeeId);
      this.fn_syncApprovalValidation();
    },
    // Get list request reason
    async fn_getListEmployeeRequestReason(type) {
      const employeeRequestReasonApiRes = await RequestReasonApi.list({
        filters:
          "type=" +
          type +
          "&disabled!=true&company_id=" +
          this.currentCompany.id +
          "|company_id=",
        limit: 2000
      });
      if (
        employeeRequestReasonApiRes.result &&
        employeeRequestReasonApiRes.result.length > 0
      ) {
        let requestSystem = [];
        let requestCompany = [];
        employeeRequestReasonApiRes.result.forEach(item => {
          if (item.company_id) {
            requestCompany.push(item);
          } else {
            requestSystem.push(item);
          }
        });
        this.mData.dataDefault.listRequestReason = [
          ...requestSystem,
          ...requestCompany
        ];
      }
    },

       // Get list nhân sự
    async fn_getListEmployeeApprovedQLTT(employeeId, allowCurrentUserFallback = true) {
      const selectedEmployeeId =
        employeeId ||
        this.mData.dataForm.employee_request.employee_id ||
        (allowCurrentUserFallback && this.currentUser ? this.currentUser.id : null);

      if (!selectedEmployeeId) {
        this.listEmployeeApprove = [];
        this.listHrApprove = [];
        return;
      }

      const targetScope = this.fn_getApprovalTargetScope(selectedEmployeeId);
      const basePayload = {
        employee_id: selectedEmployeeId,
        company_id: targetScope.company_id,
        // branch_id: targetScope.branch_id,
        // department_id: targetScope.department_id,
        feature_code: "FT1006",
        limit: 500
      };

      const [directManagerRes, hrManagerRes] = await Promise.all([
        EmployeeApi.GetDirectManagerCandidates({
          ...basePayload,
          approver_type: "QLTT"
        }),
        EmployeeApi.GetDirectManagerCandidates({
          ...basePayload,
          approver_type: "HR"
        })
      ]);
      this.fn_applyApprovalList(
        "listEmployeeApprove",
        directManagerRes && directManagerRes.result
          ? directManagerRes.result.employees
          : []
      );
      this.fn_applyApprovalList(
        "listHrApprove",
        hrManagerRes && hrManagerRes.result
          ? hrManagerRes.result.employees
          : []
      );
      this.fn_resetApprovalWhenFilteredOut();
      await this.fn_getListDirectManagerOptions(selectedEmployeeId);
      this.fn_syncApprovalValidation();
    },
    // Get list request reason
    async fn_getListEmployeeRequestReason(type) {
      const employeeRequestReasonApiRes = await RequestReasonApi.list({
        filters:
          "type=" +
          type +
          "&disabled!=true&company_id=" +
          this.currentCompany.id +
          "|company_id=",
        limit: 2000
      });
      if (
        employeeRequestReasonApiRes.result &&
        employeeRequestReasonApiRes.result.length > 0
      ) {
        let requestSystem = [];
        let requestCompany = [];
        employeeRequestReasonApiRes.result.forEach(item => {
          if (item.company_id) {
            requestCompany.push(item);
          } else {
            requestSystem.push(item);
          }
        });
        this.mData.dataDefault.listRequestReason = [
          ...requestSystem,
          ...requestCompany
        ];
      }
    },
    
    async fn_getListHoliday() {
      const currentYear = new Date().getFullYear();
      const lastYear = new Date().getFullYear() - 1;
      const dayOffApiRes = await DayOffApi.list({ filters: "year=" + currentYear + "|year=" + lastYear + "&disabled=false", limit: 2000 });
      dayOffApiRes.result.forEach(item => {
        if (item.off_date) {
          let dayFormatted = MethodService.formatDate(item.off_date, "date");
          this.listDayOffNotToReq.push(dayFormatted);
        }
      });
    },
    // Get the number of dayoffs left of employee
    async fn_getEmployeeDayOff(id) {
      const currentYear = new Date().getFullYear();
      const nextYear = new Date().getFullYear() + 1;
      const employeedayOffRes = await EmployeeDayOffApi.list({
        filters:`employee_id=${id}&year:in:${currentYear + ','+ nextYear}`
      });
      if (employeedayOffRes.result && employeedayOffRes.result.length == 1 && employeedayOffRes.result[0].year == new Date().getFullYear()) {
        this.remain_allow_dayoff_number_current_year =
          employeedayOffRes.result[0].remain_allow_dayoff_number ? employeedayOffRes.result[0].remain_allow_dayoff_number : 0;
        this.remain_unallow_dayoff_number_current_year =
          employeedayOffRes.result[0].remain_unallow_dayoff_number ? employeedayOffRes.result[0].remain_unallow_dayoff_number : 0;
        this.remain_allow_dayoff_number_next_year = null;
        this.remain_unallow_dayoff_number_next_year = null;
      } else if (employeedayOffRes.result && employeedayOffRes.result.length == 1 && employeedayOffRes.result[0].year == new Date().getFullYear() + 1) {
        this.remain_allow_dayoff_number_next_year =
          employeedayOffRes.result[0].remain_allow_dayoff_number ? employeedayOffRes.result[0].remain_allow_dayoff_number : 0;
        this.remain_unallow_dayoff_number_next_year =
          employeedayOffRes.result[0].remain_unallow_dayoff_number ? employeedayOffRes.result[0].remain_unallow_dayoff_number : 0;
        this.remain_allow_dayoff_number_current_year = null;
        this.remain_unallow_dayoff_number_current_year = null;
      } else if (employeedayOffRes.result && employeedayOffRes.result.length == 2) {
        this.remain_allow_dayoff_number_current_year =
          employeedayOffRes.result[0].remain_allow_dayoff_number ? employeedayOffRes.result[0].remain_allow_dayoff_number : 0;
        this.remain_unallow_dayoff_number_current_year =
          employeedayOffRes.result[0].remain_unallow_dayoff_number ? employeedayOffRes.result[0].remain_unallow_dayoff_number : 0;

        this.remain_allow_dayoff_number_next_year =
          employeedayOffRes.result[1].remain_allow_dayoff_number ? employeedayOffRes.result[1].remain_allow_dayoff_number : 0;
        this.remain_unallow_dayoff_number_next_year =
          employeedayOffRes.result[1].remain_unallow_dayoff_number ? employeedayOffRes.result[1].remain_unallow_dayoff_number : 0;
      } else {
        this.remain_allow_dayoff_number_current_year = null;
        this.remain_unallow_dayoff_number_current_year = null;
        this.remain_allow_dayoff_number_next_year = null;
        this.remain_unallow_dayoff_number_next_year = null;
      }

      if (!this.remain_allow_dayoff_number_current_year && !this.remain_allow_dayoff_number_next_year) {
        this.mData.dataDefault.listLoaiLyDoNghi = [
          {
            value: "LEAVE_WITHOUT_PAY",
            label: "Nghỉ không lương"
          }
        ];
      } else {
        this.mData.dataDefault.listLoaiLyDoNghi = [
          {
            value: "LEAVE_WITH_PAY",
            label: "Nghỉ có lương"
          },
          {
            value: "LEAVE_WITHOUT_PAY",
            label: "Nghỉ không lương"
          }
        ];
      }
    },

    // Reset khi chọn lại nhân viên
    fn_resetReSelectEmployee() {
      if (this.mData.dataForm.detail_request.from_date) {
        this.mData.dataForm.detail_request.from_date = undefined;
      }
      if (this.mData.dataForm.detail_request.to_date) {
        this.mData.dataForm.detail_request.to_date = undefined;
      }
      if (this.mData.dataForm.detail_request.extra_minute) {
        this.mData.dataForm.detail_request.extra_minute = undefined;
      }
      if (this.mData.dataForm.detail_request.convert_work_method) {
        this.mData.dataForm.detail_request.convert_work_method = undefined;
      }
    },
    // Get list date from to
    fn_getListDate(startDate, endDate, steps = 1) {
      const dateArray = [];
      let currentDate = new Date(startDate);
      let dateLimit = new Date(endDate);
      while (currentDate <= dateLimit) {
        dateArray.push(new Date(currentDate));
        // Use UTC date to prevent problems with time zones and DST
        currentDate.setUTCDate(currentDate.getUTCDate() + steps);
      }
      return dateArray;
    },
    // check if have employee_id -> initDataShift
    async fn_checkHasEmployee(typeRequest) {
      this.mData.reselectEmployee = true;
      let result = null;
      if (typeRequest == 'WORK_EXPLANATION') {
        result = this.mData.dataDefault.listEmployeeWorkExplanation.find(el => {
          if (el.id == this.currentUser.id) {
            this.mData.dataForm.employee_request.employee_id = this.currentUser.id;
            return el;
          }
        });
      } else {
        result = this.mData.dataDefault.listNhanVien.find(el => {
          if (el.id == this.currentUser.id) {
            this.mData.dataForm.employee_request.employee_id = this.currentUser.id;
            return el;
          }
        });
      }
      if (result && !this.mData.dataDefault.listFeature.includes("FT1007")) {
        this.isSelectEmployee = false;
        this.mData.validForm.employee_request.employee_id = [];
      } else if (this.$router.currentRoute.query.employee_id) {
        this.mData.dataForm.employee_request.employee_id = this.$router.currentRoute.query.employee_id;
        this.mData.validForm.employee_request.employee_id = [];
      }
      if (this.mData.dataForm.employee_request.employee_id &&
        this.mData.dataForm.employee_request.type != "GO_ON_BUSSINESS" &&
        this.mData.dataForm.employee_request.type != "WORK_EXPLANATION") {
        await this.fn_initDataShift();
      } else if (this.mData.dataForm.employee_request.employee_id) {
        await this.fn_getListEmployeeApproved(
          this.mData.dataForm.employee_request.employee_id,
          false
        );
      }
    },

        async fn_checkHasEmployeeQTLL(typeRequest) {
      this.mData.reselectEmployee = true;
      let result = null;
      if (typeRequest == 'WORK_EXPLANATION') {
        result = this.mData.dataDefault.listEmployeeWorkExplanation.find(el => {
          if (el.id == this.currentUser.id) {
            this.mData.dataForm.employee_request.employee_id = this.currentUser.id;
            return el;
          }
        });
      } else {
        result = this.mData.dataDefault.listNhanVien.find(el => {
          if (el.id == this.currentUser.id) {
            this.mData.dataForm.employee_request.employee_id = this.currentUser.id;
            return el;
          }
        });
      }
      if (result && !this.mData.dataDefault.listFeature.includes("FT1007")) {
        this.isSelectEmployee = false;
        this.mData.validForm.employee_request.employee_id = [];
      } else if (this.$router.currentRoute.query.employee_id) {
        this.mData.dataForm.employee_request.employee_id = this.$router.currentRoute.query.employee_id;
        this.mData.validForm.employee_request.employee_id = [];
      }
      if (this.mData.dataForm.employee_request.employee_id &&
        this.mData.dataForm.employee_request.type != "GO_ON_BUSSINESS" &&
        this.mData.dataForm.employee_request.type != "WORK_EXPLANATION") {
        await this.fn_initDataShift();
      } else if (this.mData.dataForm.employee_request.employee_id) {
        await this.fn_getListEmployeeApprovedQLTT(
          this.mData.dataForm.employee_request.employee_id,
          false
        );
      }
    },
    // Change shift reset input field
    fn_changeShift() {
      if (this.mData.dataForm.detail_request.extra_minute) {
        this.mData.dataForm.detail_request.extra_minute = undefined;
      }
      if (this.mData.dataForm.detail_request.from_date) {
        this.mData.dataForm.detail_request.from_date = undefined;
      }
      if (this.mData.dataForm.detail_request.to_date) {
        this.mData.dataForm.detail_request.to_date = undefined;
      }
      if (this.mData.dataForm.detail_request.number_of_works) {
        this.mData.dataForm.detail_request.number_of_works = undefined;
      }
      if (this.mData.dataForm.detail_request.time_work) {
        this.mData.dataForm.detail_request.time_work = undefined;
      }
      if (this.mData.dataForm.detail_request.explained_end_date) {
        this.mData.dataForm.detail_request.explained_end_date = undefined;
      }
    },

    fn_roundTo2Digit(num) {
      return !isNaN(num) ? Math.round(num * 100) / 100 : 0;
    },

    fn_getWeekNumOfMonth(d, fromMonday = true) {
      const first = new Date(d.getFullYear(), d.getMonth(), 1);
      const last = d;
      let dayOfWeek = first.getDay();
      if (fromMonday && dayOfWeek === 0) dayOfWeek = 7;
      let days = dayOfWeek + last.getDate();
      if (fromMonday) days -= 1;
      return Math.ceil(days / 7);
    },

    fn_getWeekNumOfYear(d) {
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
      // Set to nearest Thursday: current date + 4 - current day number
      // Make Sunday's day number 7
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
      // Get first day of year
      const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      // Calculate full weeks to nearest Thursday
      let weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
      // Return array of year and week number
      if (weekNo > 51) {
        weekNo = 1;
      } else {
        weekNo += 1;
      }
      return weekNo;
    },

    fn_checkHasShiftAndNumberWordDay(time, todayShiftTime) {
      const currentDay = new Date(time).getDay() == 0 ? 6 : new Date(time).getDay() - 1;
      // Get info selected shift
      const selectedShift = this.listEmployeeShiftDetail.find(o => o.id == this.mData.dataForm.detail_request.shift_id);
      let todayShift = {};
      if (selectedShift && selectedShift.work_days.length > 0) {
        if (this.typeReq == "WORK_EXPLANATION") {
          this.isPassDay = false;
          if (selectedShift.is_pass_day) {
            this.isPassDay = true;
          }
        }
        // Get today time shift
        todayShift = selectedShift.work_days[currentDay];
        if (todayShift.number_word_day) {
          this.numberWordDay = todayShift.number_word_day;
        }
        if (todayShift && todayShift.period_time.length > 0) {
          const startTime = todayShift.period_time[0].start_time && todayShift.period_time[0].start_time.hour
                              ? todayShift.period_time[0].start_time.hour : undefined
          const iteration = todayShift.iteration_cycle ? todayShift.iteration_cycle : '';
          const weekNumOfYear = this.fn_getWeekNumOfYear(time);
          const weekNumOfMonth = this.fn_getWeekNumOfMonth(time);
          const lastWeekNum = this.fn_getWeekNumOfMonth(new Date(new Date(time).getFullYear(), new Date(time).getMonth() + 1, 0));
          const nearLastWeekNum = this.fn_getWeekNumOfMonth(new Date(new Date(time).getFullYear(), new Date(time).getMonth() + 1, 0)) - 1;
          if (
            startTime && (iteration == "WEEKLY" ||
            iteration == "EVEN_WEEK_OF_MONTH" && weekNumOfYear % 2 == 0 ||
            iteration == "ODD_WEEK_OF_MONTH" && weekNumOfYear % 2 != 0 ||
            iteration == "WEEK_1_OF_MONTH" && weekNumOfMonth == 1 ||
            iteration == "WEEK_2_OF_MONTH" && weekNumOfMonth == 2 ||
            iteration == "WEEK_3_OF_MONTH" && weekNumOfMonth == 3 ||
            iteration == "WEEK_4_OF_MONTH" && weekNumOfMonth == 4 ||
            iteration == "WEEK_5_OF_MONTH" && weekNumOfMonth == 5 ||
            iteration == "NEAR_LAST_WEEK_OF_MONTH" && weekNumOfMonth == nearLastWeekNum ||
            iteration == "LAST_WEEK_OF_MONTH" && weekNumOfMonth == lastWeekNum)
          ) {
            todayShift.period_time.forEach((oddShift) => {
              if (
                Object.keys(oddShift.start_time).length !== 0 &&
                Object.keys(oddShift.end_time).length !== 0
              ) {
                todayShiftTime.push(oddShift);
              }
            });
          }
          if (todayShiftTime.length == 0) { // This shift is empty
            window.toastr.warning(
              `Ngày này nhân viên này không đăng ký làm để tạo yêu cầu`
            );
            if (this.typeReq == "WORK_EXPLANATION") {
              this.numberWordDay = 0;
              this.mData.dataForm.detail_request.number_of_works = 0;
            }
            this.createRequest = false;
            return false;
          }
          return true;
        }
      }
    },

    fn_checkValidShift(currentTime) {
      const shift = this.listEmployeeShift.find((employeeShift) => {
        if (employeeShift.start_time && employeeShift.end_time) {
          const shiftStartTime = new Date(
            employeeShift.start_time
          ).getTime();
          const shiftEndTime = new Date(employeeShift.end_time).getTime();
          if (
            employeeShift.shift_id ==
              this.mData.dataForm.detail_request.shift_id &&
            currentTime >= shiftStartTime &&
            currentTime <= shiftEndTime
          ) {
            return employeeShift;
          }
        } else if (employeeShift.start_time && !employeeShift.end_time) {
          const shiftStartTime = new Date(
            employeeShift.start_time
          ).getTime();
          if (
            employeeShift.shift_id ==
              this.mData.dataForm.detail_request.shift_id &&
            currentTime >= shiftStartTime
          ) {
            return employeeShift;
          }
        }
      });
      return shift;
    },

    fn_checkValidTimeReq(todayShiftTime, t, idEmployeeShift, reqTime) {
      if (todayShiftTime && (todayShiftTime.length == 1 && todayShiftTime[0].start_time.hour || todayShiftTime.length == 2 && !todayShiftTime[1].start_time.hour)) {
        const startTimeShift = new Date(t).setHours(
          todayShiftTime[0].start_time.hour,
          todayShiftTime[0].start_time.minute
        );
        const endTimeShift = new Date(t).setHours(
          todayShiftTime[0].end_time.hour,
          todayShiftTime[0].end_time.minute
        );
        // có 1 ca trong ngày
        this.listEmployeeShiftDetail.find((shift) => {
          if (shift.id == idEmployeeShift) {
            const acceptTimeStart = new Date(
              reqTime
            ).setHours(
              shift.acceptance_time_start.hour,
              shift.acceptance_time_start.minute,
              0
            );
            const acceptTimeEnd = new Date(reqTime).setHours(
              shift.acceptance_time_end.hour,
              shift.acceptance_time_end.minute,
              0
            );
            if (
              reqTime >= acceptTimeStart &&
              reqTime <= acceptTimeEnd &&
              reqTime > startTimeShift &&
              reqTime <= endTimeShift
            ) {
              this.validTimeCreateReq = true;
            }
          }
          return;
        });
      } else if (todayShiftTime && todayShiftTime.length == 2 && todayShiftTime[1].start_time.hour) {
        // có 2 ca. VD: ca sáng ca chiều
        const startTimeShift1 = new Date(t).setHours(
          todayShiftTime[0].start_time.hour,
          todayShiftTime[0].start_time.minute
        );
        // const endTimeShift1 = new Date(t).setHours(
        //   todayShiftTime[0].end_time.hour,
        //   todayShiftTime[0].end_time.minute
        // );
        // const startTimeShift2 = new Date(t).setHours(
        //   todayShiftTime[1].start_time.hour,
        //   todayShiftTime[1].start_time.minute
        // );
        const endTimeShift2 = new Date(t).setHours(
          todayShiftTime[1].end_time.hour,
          todayShiftTime[1].end_time.minute
        );
        this.listEmployeeShiftDetail.find((shift) => {
          if (shift.id == idEmployeeShift) {
            const acceptTimeStart = new Date(
              reqTime
            ).setHours(
              shift.acceptance_time_start.hour,
              shift.acceptance_time_start.minute,
              0
            );
            const acceptTimeEnd = new Date(reqTime).setHours(
              shift.acceptance_time_end.hour,
              shift.acceptance_time_end.minute,
              0
            );
            if (
              reqTime >= acceptTimeStart &&
              reqTime <= acceptTimeEnd &&
              reqTime > startTimeShift1 &&
              //   reqTime <= endTimeShift1) ||
              // (reqTime >= acceptTimeStart &&
              //   reqTime <= acceptTimeEnd &&
              //   reqTime >= startTimeShift2 &&
              reqTime <= endTimeShift2
            ) {
              this.validTimeCreateReq = true;
            }
          }
          return;
        });
      }
    },

    fn_setHeaderTable(dataTable) {
      this.dataTableDate = dataTable[0][0].date.map(
        (e) =>
          e.day +
          " (" +
          (new Date(
            MethodService.formatterYYYYMMDD(e.day, "date")
          ).getDay() == 0
            ? "CN"
            : "T" +
              (new Date(
                MethodService.formatterYYYYMMDD(e.day, "date")
              ).getDay() +
                1)) +
          ")"
      );
    },

    fn_formatterDate(date) {
      let datearray = date.split("/");
      return datearray[1] + "/" + datearray[0] + "/" + datearray[2];
    },

    fn_goBack() {
      if (!this.$router.currentRoute.query.from) {
        this.$router.go(-1);
        return;
      }
      this.$router.push({
        name: "Admin-ManageRequests-RequestsWaitingForApproval",
      });
    },

    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },

    forceUpdateUI() {
      this.$forceUpdate();
    },

    fn_closeDialogReject() {
      this.$refs["formRejectRequest"].resetFields();
      this.dialogRejectRequest = false;
    },

    fn_closeDialogCancel() {
      this.$refs["formCancelRequest"].resetFields();
      this.dialogCancelRequest = false;
    },

    fn_calculate(t, todayShiftTime, startTimeWork, endTimeWork) {
      let todayTimeWorked = "";
      let timeShiftToday = "";
      if (todayShiftTime.length == 1) {
        const startTimeShift = new Date(t).setHours(todayShiftTime[0].start_time.hour, todayShiftTime[0].start_time.minute);
        const endTimeShift = new Date(t).setHours(todayShiftTime[0].end_time.hour, todayShiftTime[0].end_time.minute);
        timeShiftToday = endTimeShift - startTimeShift;
        if (startTimeWork <= startTimeShift && endTimeWork <= startTimeShift || startTimeWork >= endTimeShift && endTimeWork >= endTimeShift || startTimeWork == endTimeWork) {
          this.mData.dataForm.detail_request.number_of_works = 0;
        } else if (startTimeWork <= startTimeShift && endTimeWork > startTimeShift && endTimeWork <= endTimeShift) {
          todayTimeWorked = endTimeWork - startTimeShift;
        } else if (startTimeWork <= startTimeShift && endTimeWork >= endTimeShift) {
          todayTimeWorked = endTimeShift - startTimeShift;
        } else if (startTimeWork > startTimeShift && startTimeWork < endTimeShift && endTimeWork < endTimeShift) {
          todayTimeWorked = endTimeWork - startTimeWork;
        } else if (startTimeWork > startTimeShift && startTimeWork < endTimeShift && endTimeWork >= endTimeShift) {
          todayTimeWorked = endTimeShift - startTimeWork;
        }
      } else if (todayShiftTime.length == 2) {
        const startTimeShift1 = new Date(t).setHours(todayShiftTime[0].start_time.hour, todayShiftTime[0].start_time.minute);
        const endTimeShift1 = new Date(t).setHours(todayShiftTime[0].end_time.hour, todayShiftTime[0].end_time.minute);
        const startTimeShift2 = new Date(t).setHours(todayShiftTime[1].start_time.hour, todayShiftTime[1].start_time.minute);
        const endTimeShift2 = new Date(t).setHours(todayShiftTime[1].end_time.hour, todayShiftTime[1].end_time.minute);
        timeShiftToday = endTimeShift1 - startTimeShift1 + endTimeShift2 - startTimeShift2;
        if (startTimeWork == endTimeWork || startTimeWork <= startTimeShift1 && endTimeWork <= startTimeShift1 || startTimeWork >= endTimeShift1 && endTimeWork <= startTimeShift2 || startTimeWork >= endTimeShift2 && endTimeWork <= startTimeShift2) {
          this.mData.dataForm.detail_request.number_of_works = 0;
        } else if (startTimeWork <= startTimeShift1 && endTimeWork > startTimeShift1 && endTimeWork <= endTimeShift1) {
          todayTimeWorked = endTimeWork - startTimeShift1;
        } else if (startTimeWork <= startTimeShift1 && endTimeWork >= endTimeShift1 && endTimeWork <= startTimeShift2) {
          todayTimeWorked = endTimeShift1 - startTimeShift1;
        } else if (startTimeWork <= startTimeShift1 && endTimeWork > startTimeShift2 && endTimeWork <= endTimeShift2) {
          todayTimeWorked = endTimeShift1 - startTimeShift1 + endTimeWork - startTimeShift2;
        } else if (startTimeWork <= startTimeShift1 && endTimeWork >= endTimeShift2) {
          todayTimeWorked = endTimeShift1 - startTimeShift1 + endTimeShift2 - startTimeShift2;
        } else if (startTimeWork > startTimeShift1 && startTimeWork < endTimeShift1 && endTimeWork <= endTimeShift1) {
          todayTimeWorked = endTimeWork - startTimeWork;
        } else if (startTimeWork > startTimeShift1 && startTimeWork < endTimeShift1 && endTimeWork > endTimeShift1 && endTimeWork <= startTimeShift2) {
          todayTimeWorked = endTimeShift1 - startTimeWork;
        } else if (startTimeWork > startTimeShift1 && startTimeWork < endTimeShift1 && endTimeWork > startTimeShift2 && endTimeWork <= endTimeShift2) {
          todayTimeWorked = endTimeShift1 - startTimeWork + endTimeWork - startTimeShift2;
        } else if (startTimeWork > startTimeShift1 && startTimeWork < endTimeShift1 && endTimeWork > endTimeShift2) {
          todayTimeWorked = endTimeShift1 - startTimeWork + endTimeShift2 - startTimeShift2;
        } else if (startTimeWork >= endTimeShift1 && startTimeWork < startTimeShift2 && endTimeWork > startTimeShift2 && endTimeWork <= endTimeShift2) {
          todayTimeWorked = endTimeWork - startTimeShift2;
        } else if (startTimeWork > startTimeShift2 && startTimeWork < endTimeShift2 && endTimeWork >= endTimeShift2) {
          todayTimeWorked = endTimeShift2 - startTimeWork;
        }
      }
      const raw = (todayTimeWorked / timeShiftToday) * this.numberWordDay;
      this.mData.dataForm.detail_request.number_of_works = this.fn_roundTo2Digit(raw <= 0 ? 0 : raw);
    },

    fn_calWorkPassDayShift() {
      const currentTime = new Date().getTime();
      const startTime = new Date(this.mData.dataForm.detail_request.explained_start_date).getTime();
      const endTime = new Date(this.mData.dataForm.detail_request.explained_end_date).getTime();
      if (startTime && startTime > currentTime) {
        this.mData.dataForm.detail_request.explained_start_date = undefined;
        window.toastr.warning("Thời gian giải trình công phải là trước thời điểm hiện tại !");
      } else if (endTime && endTime > currentTime) {
        this.mData.dataForm.detail_request.explained_end_date = undefined;
        window.toastr.warning("Thời gian giải trình công phải là trước thời điểm hiện tại !");
      } else if (startTime && endTime && startTime > endTime) {
        this.mData.dataForm.detail_request.explained_end_date = undefined;
        window.toastr.warning("Mốc 'tới' phải là lớn hơn hoặc bằng mốc 'Thời gian từ' !");
      } else {
        const t = this.mData.dataForm.detail_request.explained_start_date;
        let todayShiftTime = [];
        this.fn_checkHasShiftAndNumberWordDay(t, todayShiftTime);
        let todayTimeWorked = "";
        let timeShiftToday = "";
        if (todayShiftTime.length == 1) {
          const startTimeShift = new Date(startTime).setHours(todayShiftTime[0].start_time.hour, todayShiftTime[0].start_time.minute);
          const endTimeShift = new Date(endTime).setHours(todayShiftTime[0].end_time.hour, todayShiftTime[0].end_time.minute);
          timeShiftToday = endTimeShift - startTimeShift;
          if (startTime <= startTimeShift && endTime <= startTimeShift || startTime >= endTimeShift && endTime >= endTimeShift || startTime == endTime) {
            this.mData.dataForm.detail_request.number_of_works = 0;
          } else if (startTime <= startTimeShift && endTime > startTimeShift && endTime <= endTimeShift) {
            todayTimeWorked = endTime - startTimeShift;
          } else if (startTime <= startTimeShift && endTime >= endTimeShift) {
            todayTimeWorked = endTimeShift - startTimeShift;
          } else if (startTime > startTimeShift && startTime < endTimeShift && endTime < endTimeShift) {
            todayTimeWorked = endTime - startTime;
          } else if (startTime > startTimeShift && startTime < endTimeShift && endTime >= endTimeShift) {
            todayTimeWorked = endTimeShift - startTime;
          }
          const raw = (todayTimeWorked / timeShiftToday) * this.numberWordDay;
          this.mData.dataForm.detail_request.number_of_works = this.fn_roundTo2Digit(raw <= 0 ? 0 : raw);
        }
      }
    },

    async fn_calWork() {
      if (!this.mData.dataForm.detail_request.explained_start_date) {
        window.toastr.warning("Vui lòng chọn Ngày giải trình");
        this.mData.dataForm.detail_request.time_work = undefined;
      } else {
        if (
          this.mData.dataForm.detail_request.time_work &&
          this.mData.dataForm.detail_request.time_work[0] &&
          this.mData.dataForm.detail_request.time_work[1]
        ) {
          const t = new Date(this.mData.dataForm.detail_request.explained_start_date);
          const startTime = this.mData.dataForm.detail_request.time_work[0];
          const endTime = this.mData.dataForm.detail_request.time_work[1];
          const startTimeWork = new Date(t.getFullYear(), t.getMonth(), t.getDate(), startTime.getHours(), startTime.getMinutes()).getTime();
          const endTimeWork = new Date(t.getFullYear(), t.getMonth(), t.getDate(), endTime.getHours(), endTime.getMinutes()).getTime();
          let todayShiftTime = [];
          this.fn_checkHasShiftAndNumberWordDay(t, todayShiftTime);
          this.fn_calculate(t, todayShiftTime, startTimeWork, endTimeWork);
        } else {
          if (this.mData.dataForm.detail_request.number_of_works) {
            this.mData.dataForm.detail_request.number_of_works = 0;
          }
        }
      }
    },
  }
};
